<template>
  <DashboardWidget
    :widget="widget"
    :ui="ui"
    :widgetData="widgetData"
  >
    <template #item="{ item: project }">
      <div class="space-x-3 flex items-center">
        <ProjectLogoNew
          :project="project"
        />
        <router-link
          :to="`/projects/${project.id}`"
          class="space-x-3 flex items-center"
        >
          <div class="line-clamp-1 text-sm text-gray-500">
            {{ project.attributes.name }}
          </div>
          <Status
            :row="project"
          />
        </router-link>
      </div>
    </template>
  </DashboardWidget>
</template>
<script lang="ts" setup>
// Components
import Status from "@/components/table/Status.vue";
import DashboardWidget from "@/modules/dashboard/components/widgets/DashboardWidget.vue";
import ProjectLogoNew from "@/modules/projects/components/ProjectLogoNew.vue";

// Utils
import i18n from "@/i18n";
import { PropType, computed } from 'vue'
import { DashboardWidgetType, WidgetUI, WidgetData } from "@/modules/dashboard/utils/widgetUtils"
import { extraFilters } from '@/modules/projects/utils/projectTableUtils'

// Composables
import { useStore } from 'vuex'
import useCan from "@/modules/common/composables/useCan"
const { can, actions } = useCan()

const store = useStore()

const props = defineProps({
  widget: {
    type: Object as PropType<DashboardWidgetType>,
    required: true
  }
})

const projectsPath = computed(() => {
  const viewOptions = store.getters['users/defaultTargetViewOptions']('projects')
  const view_type = viewOptions?.view_type || 'list'

  return `/projects/${view_type}`
})

const ui = computed<WidgetUI>(() => {
  return {
    listPath: projectsPath.value,
    listLabel: i18n.t('Go to projects'),
    entityCreate: can(actions.CREATE_PROJECTS) ? '/projects/add' : '',
    footerKey: 'showing active projects'
  }
})

const widgetData = computed<WidgetData>(() => {
  return {
    target: 'projects',
    dataGetterPath: 'projects/projectsOrTemplatesData',
    groupedDataGetter: 'projects/groupedProjects',
    extraFilters,
    loading: store.state.projects.projectsLoading
  }
})
</script>
